import { useEffect, useState } from "react";
import axios from "axios";
import { LogOut, ExternalLink } from "lucide-react";
import { API, TOKEN_KEY, authHeaders } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { EventsTab } from "@/components/admin/EventsTab";
import { MessagesTab } from "@/components/admin/MessagesTab";

const AdminShell = ({ onLogout }) => (
  <div className="min-h-screen bg-[#F6F1FD] text-[#1C1430]" data-testid="admin-dashboard">
    <header className="bg-[#170B2E] text-white">
      <div className="wrap flex items-center justify-between h-[72px] gap-4">
        <div className="flex items-center gap-3">
          <img src="/assets/logo-dark.jpg" alt="" className="w-[52px] h-auto shrink-0 rounded-md" />
          <div>
            <div className="font-display text-xl leading-none">Davis Infinite Care</div>
            <div className="text-[11px] tracking-[.18em] font-bold text-[#F4B41A]">ADMIN</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <a href="/" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-bold hover:text-[#F4B41A] transition-colors px-3" data-testid="admin-view-site-link">
            View site <ExternalLink className="w-4 h-4" />
          </a>
          <Button onClick={onLogout} className="rounded-full bg-[#F4B41A] text-[#170B2E] hover:bg-[#FFC93C] font-extrabold" data-testid="admin-logout-button">
            <LogOut className="w-4 h-4" /> Log out
          </Button>
        </div>
      </div>
    </header>
    <main className="wrap py-10">
      <Tabs defaultValue="events">
        <TabsList className="bg-white border border-[#E4DCF2] h-12 p-1 rounded-full" data-testid="admin-tabs">
          <TabsTrigger value="events" className="rounded-full px-6 h-10 font-bold data-[state=active]:bg-[#5A2D9C] data-[state=active]:text-white" data-testid="admin-tab-events">Events</TabsTrigger>
          <TabsTrigger value="messages" className="rounded-full px-6 h-10 font-bold data-[state=active]:bg-[#5A2D9C] data-[state=active]:text-white" data-testid="admin-tab-messages">Messages</TabsTrigger>
        </TabsList>
        <TabsContent value="events" className="mt-8"><EventsTab onUnauthorized={onLogout} /></TabsContent>
        <TabsContent value="messages" className="mt-8"><MessagesTab onUnauthorized={onLogout} /></TabsContent>
      </Tabs>
    </main>
  </div>
);

export default function AdminPage() {
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setAuthed(false);
    axios.get(`${API}/auth/me`, { headers: authHeaders() })
      .then(() => setAuthed(true))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setAuthed(false); });
  }, []);

  const logout = () => { localStorage.removeItem(TOKEN_KEY); setAuthed(false); };

  if (authed === null) return <div className="min-h-screen bg-[#170B2E]" data-testid="admin-loading" />;
  if (!authed) return <AdminLogin onLogin={() => setAuthed(true)} />;
  return <AdminShell onLogout={logout} />;
}
